import React from 'react';
import Modal from '../common/Modal';

const RequestDetailsModal = ({ request, onClose }) => {
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <Modal onClose={onClose} title="Signup Request Details" size="large">
      <div className="request-details">
        <div className="details-grid">
          <div className="detail-section">
            <h3>Organization Information</h3>
            <div className="detail-items">
              <div className="detail-item">
                <label>Organization Name:</label>
                <span>{request.organization_name}</span>
              </div>
              
              <div className="detail-item">
                <label>Contact Person:</label>
                <span>{request.contact_person}</span>
              </div>
              
              <div className="detail-item">
                <label>Email Address:</label>
                <span>
                  <a href={`mailto:${request.email}`}>{request.email}</a>
                </span>
              </div>
              
              {request.phone && (
                <div className="detail-item">
                  <label>Phone Number:</label>
                  <span>{request.phone}</span>
                </div>
              )}
              
              {request.website && (
                <div className="detail-item">
                  <label>Website:</label>
                  <span>
                    <a href={request.website} target="_blank" rel="noopener noreferrer">
                      {request.website}
                      <i className="fas fa-external-link-alt"></i>
                    </a>
                  </span>
                </div>
              )}
            </div>
          </div>

          <div className="detail-section">
            <h3>Request Status</h3>
            <div className="detail-items">
              <div className="detail-item">
                <label>Current Status:</label>
                <span className={`status-badge status-${request.status}`}>
                  {request.status.charAt(0).toUpperCase() + request.status.slice(1)}
                </span>
              </div>
              
              <div className="detail-item">
                <label>Submitted:</label>
                <span>{formatDate(request.created_at)}</span>
              </div>
              
              {request.approved_at && (
                <div className="detail-item">
                  <label>Processed:</label>
                  <span>{formatDate(request.approved_at)}</span>
                </div>
              )}
              
              {request.approver && (
                <div className="detail-item">
                  <label>Processed By:</label>
                  <span>{request.approver.name}</span>
                </div>
              )}
            </div>
          </div>
        </div>

        {request.description && (
          <div className="detail-section full-width">
            <h3>Organization Description</h3>
            <div className="description-content">
              {request.description}
            </div>
          </div>
        )}

        {request.admin_notes && (
          <div className="detail-section full-width">
            <h3>Admin Notes</h3>
            <div className="notes-content">
              {request.admin_notes}
            </div>
          </div>
        )}

        {request.rejection_reason && (
          <div className="detail-section full-width rejection-section">
            <h3>Rejection Reason</h3>
            <div className="rejection-content">
              {request.rejection_reason}
            </div>
          </div>
        )}

        {request.tenant && (
          <div className="detail-section full-width">
            <h3>Associated Tenant</h3>
            <div className="tenant-info">
              <div className="tenant-item">
                <label>Tenant Name:</label>
                <span>{request.tenant.name}</span>
              </div>
              <div className="tenant-item">
                <label>Slug:</label>
                <span>{request.tenant.slug}</span>
              </div>
              <div className="tenant-item">
                <label>Status:</label>
                <span className={`status-badge status-${request.tenant.status}`}>
                  {request.tenant.status}
                </span>
              </div>
              {request.tenant.domain && (
                <div className="tenant-item">
                  <label>Domain:</label>
                  <span>{request.tenant.domain}</span>
                </div>
              )}
              {request.tenant.subdomain && (
                <div className="tenant-item">
                  <label>Subdomain:</label>
                  <span>{request.tenant.subdomain}.abfisaas.com</span>
                </div>
              )}
            </div>
          </div>
        )}

        <div className="modal-actions">
          <button onClick={onClose} className="btn-primary">
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default RequestDetailsModal;